<template>
  <div>
    <b-modal ref="modal" title="Cliente" header-class="border-bottom-0 pb-0" footer-class="border-top-0">
      <div class="container-fluid">
        <div class="row mb-4">
          <b-form-input v-model="search" type="text" autofocus debounce="400" placeholder="Pesquisar..." @input="select()" />
        </div>
      </div>
      <b-table
        ref="table"
        borderless
        hover
        select-mode="single"
        selectable
        thead-class="d-none"
        :items="searchResults.data"
        :fields="fields"
        @row-selected="selectClient"
      >
        <template #cell(client)="data">
          <avatar
            inline
            color="#fff"
            :size="25"
            :username="data.item.name"
            :initials="getInitial(data.item.name)"
          />
          <span class="ml-2">{{ data.item.name }}</span>
        </template>
      </b-table>
      <div slot="modal-footer" class="text-right">
        <button role="button" class="btn btn-success" style="margin-left:5px" @click="$refs.modal.hide()">
          <i class="fas fa-arrow-left"></i> Voltar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>

import Avatar from "vue-avatar";

export default {
  components : {
    Avatar
  },

  props: {
    form : {}
  },

  data: () => ({
    search: null,
    searchResults: {
      data: []
    },

    fields: [{ key: "client", label: "" }]
  }),

  methods: {
    open() {
      this.$refs.modal.show();
      
      this.select(1)
    },

    getInitial(value) {
      return value.slice(0, 1);
    },

    select(page = 1) {
      axios
        .post("api/person/select?page=" + page, {name : this.search, status : 1})
        .then(response => {
          this.searchResults = response.data;
        })
        .catch(error => {
          this.error = error;
        });
    },

    selectClient(data) {
      this.$emit('input', { id: data[0].id, name: data[0].name });
      this.$refs.modal.hide();
    }
  }
};
</script>

<style>
</style>